import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Link = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 5L10.5 5C12.1569 5 13.5 6.34315 13.5 8C13.5 9.65686 12.1569 11 10.5 11H9M7 5L5.5 5C3.84315 5 2.5 6.34315 2.5 8C2.5 9.65685 3.84315 11 5.5 11H7M10 8H6"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
Link.displayName = 'Link'

export default Link
